import styled from '@emotion/styled';
import { Button } from 'antd';
import { useTranslate } from '@tolgee/react';

/** 方案目录加载失败的兜底：给出原因与重试入口，避免切换价区后永远转 Loading */
export const CatalogErrorRetry = (props: { onRetry: () => void }) => {
  const { onRetry } = props;
  const { t } = useTranslate();

  return (
    <Wrap>
      <Text>{t('方案目录加载失败，请稍后重试')}</Text>
      <Button size="small" onClick={() => onRetry()}>
        {t('重新加载')}
      </Button>
    </Wrap>
  );
};

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 0;
`;
const Text = styled.div`
  color: var(--fett-text-secondary);
`;
